import dynamic from "next/dynamic";
import { NextSeo } from "next-seo";
import Layout from "@/components/layout";

const Top = dynamic(() => import("@/components/standards/top"), {
  suspense: true,
});

const Banner = dynamic(() => import("@/components/standards/banner"), {
  suspense: true,
});

const QMS = dynamic(() => import("@/components/standards/qms"), {
  suspense: true,
});

const InfoSec = dynamic(() => import("@/components/standards/info-sec"), {
  suspense: true,
});

const Privacy = dynamic(() => import("@/components/standards/privacy"), {
  suspense: true,
});

const Sustainability = dynamic(
  () => import("@/components/standards/sustainability"),
  {
    suspense: true,
  }
);

const Health = dynamic(() => import("@/components/standards/health"), {
  suspense: true,
});

export default function Standards() {
  return (
    <Layout>
      <NextSeo
        title="Choose the Right Standards for Your Business"
        canonical="https://isauditr.com/standards"
        description="ISO Certification Services for multiple industries. Quality Management Systems | Information Security | Privacy & Data Protection | Health & Safety"
        twitter={{
          cardType: "summary_large_image",
          site: "@isauditr",
          handle: "@isauditr",
          creator: "@isauditr",
          title: "Choose the Right Standards for Your Business",
          description:
            "ISO Certification Services for multiple industries. Quality Management Systems | Information Security | Privacy & Data Protection | Health & Safety",
        }}
        openGraph={{
          type: `article`,
          locale: `en_US`,
          siteName: "IS Auditr",
          title: "Choose the Right Standards for Your Business",
          description:
            "ISO Certification Services for multiple industries. Quality Management Systems | Information Security | Privacy & Data Protection | Health & Safety",
          url: `https://isauditr.com/standards`,
          publisherName: "IS Auditr",
          publisherLogo: "https://isauditr.com/images/logo.svg",
        }}
      />

      <div
        data-elementor-type="wp-page"
        data-elementor-id="27"
        className="elementor elementor-27"
      >
        <Top
          title="Compliance and Efficiency through ISO Standards"
          subTitle="Optimize Your Business and Customer Satisfaction with our ISO Standard Solutions"
        />
        <Banner />
        <QMS />
        <InfoSec />
        <Privacy />
        <Sustainability />
        <Health />
      </div>
    </Layout>
  );
}
